import { render } from "./TwoFactorAuthModal.vue?vue&type=template&id=09c620dd"
import script from "./TwoFactorAuthModal.vue?vue&type=script&lang=ts"
export * from "./TwoFactorAuthModal.vue?vue&type=script&lang=ts"
script.render = render

export default script